import {
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

interface Props {
  tableHeadings: { [key: string]: string };
}

const ROWS = 10;

const SkeletonRow = () => (
  <TableRow
    sx={{
      "& > *": {
        borderBottom: "1px solid rgba(224, 224, 224, 1) !important",
      },
    }}
  >
    {/* Brand Name: edit icon + bold text */}
    <TableCell>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Skeleton variant="rounded" width={18} height={18} animation="wave" />
        <Skeleton variant="rounded" width={100} height={16} animation="wave" />
      </Stack>
    </TableCell>

    {/* Brand ID */}
    <TableCell>
      <Skeleton variant="rounded" width={40} height={16} animation="wave" />
    </TableCell>

    {/* Website: purple pill chip */}
    <TableCell>
      <Skeleton variant="rounded" width={170} height={24} animation="wave" sx={{ borderRadius: "16px" }} />
    </TableCell>

    {/* Status: badge shape */}
    <TableCell>
      <Skeleton variant="rounded" width={90} height={26} animation="wave" sx={{ borderRadius: "4px" }} />
    </TableCell>

    {/* Plan name: long text */}
    <TableCell>
      <Skeleton variant="rounded" width={380} height={16} animation="wave" />
    </TableCell>

    {/* Plan Term */}
    <TableCell>
      <Skeleton variant="rounded" width={130} height={16} animation="wave" />
    </TableCell>

    {/* CPA */}
    <TableCell>
      <Skeleton variant="rounded" width={50} height={16} animation="wave" />
    </TableCell>

    {/* RS */}
    <TableCell>
      <Skeleton variant="rounded" width={40} height={16} animation="wave" />
    </TableCell>

    {/* Currency */}
    <TableCell>
      <Skeleton variant="rounded" width={55} height={16} animation="wave" />
    </TableCell>
  </TableRow>
);

const CommissionPlansTableSkeleton = ({ tableHeadings }: Props) => {
  return (
    <Paper sx={{ boxShadow: "none" }}>
      <TableContainer>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {Object.values(tableHeadings).map((heading: string) => (
                <TableCell
                  key={heading}
                  align="left"
                  sx={{ fontWeight: 500, color: "rgba(0,0,0,0.87)" }}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: ROWS }).map((_, idx) => (
              <SkeletonRow key={idx} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default CommissionPlansTableSkeleton;
